<template>
  <div class="bt ff-regular">
    <div
      class="h-48 bg-FFFFFF p-0-16 fb fb-main-between fb-cross-center font-34 mb-12"
    >
      <div class="c-171A1D" @click="datePickerVisible = true">
        {{ computedTermLabel }}
        <i class="iconfont">&#xe613;</i>
      </div>
      <router-link :to="{ path: '/semester' }">
        <div class="c-006AFE">设置</div>
      </router-link>
    </div>
    <div class="p-0-16 bg-FFFFFF c-171A1D font-34">
      <div class="h-48 fb fb-cross-center">
        <i class="iconfont" @click="prev">&#xe600;</i>
        <span>{{ currentMonth }}</span>
        <i class="iconfont" @click="next">&#xe601;</i>
      </div>
    </div>
    <div class="bg-FFFFFF">
      <div class="fb c-171A1D-60 font-30 ff-scthin text-center h-38 w-full">
        <div
          v-for="v in weeks"
          :key="v"
          class="h-full fb fb-around-center fb-cross-center item-flex-1"
          >{{ v }}</div
        >
      </div>
      <div class="fb fb-wrap font-32 c-171A1D text-bold-400">
        <div
          class="item w-p-14 text-center bb-F2F2F6 pt-10 h-107 relative"
          v-for="(item, index) in times"
          :key="index"
          :class="{
            'holiday-active': item.restDay,
            'course-active': item.workDay
          }"
          @click="edit(item)"
        >
          {{ item.day }}
          <div class="item-tag holiday-tag absolute" v-if="item.restDay"
            >假</div
          >
          <div class="item-tag course-tag absolute" v-if="item.workDay">课</div>
          <div class="course-sync" v-if="item.workDay">
            同步上课日期 {{ dateToTime(item.targetDimDay, '.') }}
          </div>
        </div>
      </div>
    </div>
    <!-- 时间选择组件 -->
    <common-date-picker
      v-model="datePickerVisible"
      v-if="pageLoad && this.$store.state.semesterSetting.termOrder"
      ref="picker"
      class="evaluation-date-picker"
      :visibleItemCount="3"
      :label-config="labelConfig"
      :campus-id="campusId"
      :is-use-term-index="isUseTermIndex"
      :default-index="defaultIndex"
      :show-complete-date="true"
      @confirm="handlerPickerConfirm"
      @init-date="handlerPicker"
    ></common-date-picker>
    <!-- 时间选择组件 -->
  </div>
</template>

<script>
import mixin from '@/mixin'
import Calendar from '@/utils/calendar'
import { commonDatePicker } from '@/components'
import API from '@/api'
import { dateToTime, timeFormat } from '@/utils/comUtils'

export default {
  name: 'PageSchoolCalendar',
  mixins: [mixin],
  components: { commonDatePicker },
  props: {},
  data() {
    return {
      dateToTime,
      weeks: ['一', '二', '三', '四', '五', '六', '日'],
      times: [],
      pageLoad: false,
      calendarInstance: null,
      currentDate: null,
      currentMonth: null,
      filterTermOrder: this.$store.state.semesterSetting.termOrder,
      datePickerVisible: false,
      labelConfig: {
        chooseDate: false,
        chooseMonth: false,
        chooseWeek: false,
        chooseTerm: true
      },
      isUseTermIndex: false,
      defaultIndex: [],
      datePickerValueMap: {
        dateStr: '',
        endDimDay: 0,
        labelType: '',
        startDimDay: 0
      }
    }
  },
  computed: {
    computedTermLabel() {
      let options = this.$store.getters.semesterOptions
      const { schoolYear = 2022 } =
        options.find(item => item.schoolTermOrder === this.filterTermOrder) ||
        {}
      return `${schoolYear} - ${schoolYear + 1}学年 第${
        this.filterTermOrder === 1 ? '一' : '二'
      }学期`
    }
  },
  watch: {},
  beforeCreate() {},
  async created() {
    try {
      await this.$store.dispatch('handlerCheckSemester')
    } catch (error) {
      console.log(error)
    }
    this.pageLoad = true
    this.initCalendar()
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  async activated() {
    this.times = []
    try {
      await this.$store.dispatch('handlerCheckSemester')
    } catch (error) {
      console.log(error)
    }
    this.pageLoad = true
    this.initCalendar()
  },
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 初始化日期
    initCalendar() {
      this.calendarInstance && (this.calendarInstance = null)
      let currentDate = timeFormat(new Date(), 'YYYYMMDD')
      let semesterList = this.$store.getters.semesterOptions
      let options =
        semesterList.find(
          v => v.schoolTermOrder === (this.filterTermOrder || 1)
        ) || {}
      // 处理仅有一个学期的情况
      if (!options.schoolTermStartDimDay && semesterList.length) {
        options = semesterList[0]
      }
      const { schoolTermStartDimDay: start, schoolTermEndDimDay: end } = options
      if (!start && !end) {
        let that = this
        this.$Dialog({
          type: 'confirm',
          title: '提示',
          content: `请完善学年学期`,
          onConfirm() {
            that.$router.push({
              name: 'PageSchoolYearSemester'
            })
          }
        }).show()
        return false
      }
      this.currentDate = new Date(
        dateToTime(
          currentDate < start ? start : currentDate > end ? end : currentDate,
          '-'
        )
      )
      this.currentMonth =
        timeFormat(new Date(this.currentDate), 'YYYY') +
        '-' +
        timeFormat(new Date(this.currentDate), 'MM')
      this.calendarInstance = new Calendar(this.currentDate)
      this.calendarInstance.render((data, year, month) => {
        this.times = data
        this.currentMonth = `${year}.${month}`
        this.updateList()
      })
    },
    updateList() {
      API.schoolCalendarQueryList({
        startDimDay: this.times[0].completeDay,
        endDimDay: this.times[this.times.length - 1].completeDay,
        orgId: this.orgId,
        operUserDingId: this.dingUserId,
        operUserName: this.dingUserName,
        ...this.commonParams
      })
        .then(res => {
          if (res.schoolCalendarDetailList) {
            for (let index = 0; index < this.times.length; index++) {
              const { completeDay } = this.times[index]
              let item = res.schoolCalendarDetailList.find(
                v => +v.sourceDimDay === +completeDay
              )
              this.times[index] = { ...this.times[index], ...item }
            }
          }
          this.$forceUpdate()
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    handlerPickerConfirm({ activeValue }) {
      const { endDimDay, startDimDay } = activeValue
      let options = this.$store.getters.semesterOptions
      const { schoolTermOrder } = options.find(
        v =>
          v.schoolTermEndDimDay === endDimDay &&
          v.schoolTermStartDimDay === startDimDay
      )
      this.filterTermOrder = schoolTermOrder
      this.initCalendar()
    },
    handlerPicker(pickerValue) {
      let { dateStr, activeValue } = pickerValue
      this.datePickerValueMap = {
        dateStr,
        endDimDay: activeValue.endDimDay,
        labelType: activeValue.labelType,
        startDimDay: activeValue.startDimDay
      }
    },
    edit(item) {
      if (item.sourceDimDay < timeFormat(new Date(), 'YYYYMMDD')) {
        return
      }
      let options = this.$store.getters.semesterOptions
      const { schoolTermEndDimDay } =
        options.find(item => item.schoolTermOrder === this.filterTermOrder) ||
        {}
      this.$router.push({
        name: 'PageSchoolCalendarEdit',
        query: { ...item, schoolTermEndDimDay }
      })
    },
    prev() {
      let options = this.$store.getters.semesterOptions
      const { schoolTermStartDimDay } =
        options.find(item => item.schoolTermOrder === this.filterTermOrder) ||
        {}
      let startDimDay = String(schoolTermStartDimDay)
      const minDimDay = startDimDay.slice(0, startDimDay.length - 2)
      const formMonth = this.currentMonth.replace('.', '')
      if (formMonth > minDimDay) {
        this.calendarInstance.prevMonth((year, month) => {
          this.currentMonth = `${year}.${month}`
        })
      }
    },
    next() {
      let options = this.$store.getters.semesterOptions
      const { schoolTermEndDimDay } =
        options.find(item => item.schoolTermOrder === this.filterTermOrder) ||
        {}
      let endDimDay = String(schoolTermEndDimDay)
      const maxDimDay = endDimDay.slice(0, endDimDay.length - 2)
      const formMonth = this.currentMonth.replace('.', '')
      if (formMonth < +maxDimDay) {
        this.calendarInstance.nextMonth((year, month) => {
          this.currentMonth = `${year}.${month}`
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bb-F2F2F6 {
  border-bottom: 1px solid #f2f2f6;
}
.holiday-active {
  background: rgba(0, 176, 66, 0.12);
}
.item-tag {
  top: 4px;
  left: 4px;
  color: #00b042;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  font-size: 12px;
}
.holiday-tag {
  color: #00b042;
}
.course-active {
  background: rgba(255, 146, 0, 0.12);
}
.course-tag {
  color: #ff9200;
}
.course-sync {
  color: rgba(0, 0, 0, 0.6);
  font-size: 11px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  word-wrap: break-word;
  text-align: left;
  padding: 0 2px;
}
</style>
